import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { LoadingPage } from '@/pages/LoadingPage';
import useVerification from '@/hooks/useVerification';
import { getSafeRedirectPath } from '@/utils/auth';

function MagicLoginCallback({ addInvestor }: { addInvestor?: boolean }) {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    isVerified,
    redirectUrl,
    error: errorVerification,
  } = useVerification(location.search, addInvestor ?? false);

  useEffect(() => {
    if (isVerified) {
      navigate(getSafeRedirectPath(redirectUrl));
    }
    if (errorVerification) {
      navigate(`/login?error=${addInvestor ? 'addInvestor' : 'login'}`);
    }
  }, [isVerified, errorVerification, redirectUrl, addInvestor, navigate]);

  return (
    <div>
      <LoadingPage />
    </div>
  );
}

export default MagicLoginCallback;
